var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#2C3E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4202 12.7574V12.1949C14.4202 12.0835 14.3454 12.0093 14.2318 12.0093H13.8577V11.4445C13.8577 11.3326 13.7829 11.2566 13.6716 11.2566H13.2969V7.12507H13.6693C13.7812 7.12507 13.8577 7.05082 13.8577 6.9372V6.3747H14.2318C14.2759 6.37655 14.3191 6.36226 14.3534 6.3345C14.3877 6.30675 14.4106 6.26744 14.418 6.22395C14.4371 6.13057 14.3994 6.05632 14.3252 6.01695L9.08381 3.38895C9.02949 3.37035 8.97051 3.37035 8.91619 3.38895L3.48694 6.01695C3.45129 6.03636 3.42292 6.06681 3.40608 6.10374C3.38924 6.14067 3.38484 6.18206 3.39356 6.2217C3.39356 6.31732 3.46837 6.3747 3.56119 6.3747H4.12369V6.9372C4.12369 7.04857 4.1985 7.12282 4.30988 7.12282H4.6845V11.2566H4.31212C4.19962 11.2566 4.12369 11.3309 4.12369 11.4423V12.007H3.74962C3.63712 12.007 3.56288 12.0813 3.56288 12.1932V12.7574C3.4515 12.7574 3.375 12.8322 3.375 12.9458C3.375 13.0594 3.44925 13.1337 3.56119 13.1337H14.4202C14.5316 13.1337 14.6081 13.0594 14.6081 12.9481C14.6081 12.8356 14.5339 12.7574 14.4225 12.7574H14.4202ZM4.49606 6.74876V6.3747H13.4814V6.74876H4.49606ZM12.1702 7.12564V11.2566H11.4233V7.12507H12.1702V7.12564ZM10.2983 7.12564V11.2566H9.54956V7.12507H10.2977L10.2983 7.12564ZM8.42625 7.12564V11.2566H7.67925V7.12507H8.42625V7.12564ZM6.55425 7.12564V11.2566H5.80781V7.12507H6.55425V7.12564ZM13.4814 12.007H4.49831V11.6307H13.4831V12.007H13.4814Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32658"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolis);
export default __webpack_public_path__ + "static/media/polis.c349247538f954abb1f79fba9ce477c4.svg";
export { ForwardRef as ReactComponent };